import { useState } from "react";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { useAuth } from "@/hooks/useAuth";
import { BrokerPortalGate } from "@/components/brokerPortal/BrokerPortalGate";
import { BrokerPortalNav } from "@/components/brokerPortal/BrokerPortalNav";
import { BrokerDashboardTab } from "@/components/brokerPortal/BrokerDashboardTab";
import { BrokerPostLoadTab } from "@/components/brokerPortal/BrokerPostLoadTab";
import { BrokerLoadsTab } from "@/components/brokerPortal/BrokerLoadsTab";
import { BrokerFindDriversTab } from "@/components/brokerPortal/BrokerFindDriversTab";
import { BrokerMyDriversTab } from "@/components/brokerPortal/BrokerMyDriversTab";
import { BrokerGroupsTab } from "@/components/brokerPortal/BrokerGroupsTab";
import { BrokerServiceLogsTab } from "@/components/brokerPortal/BrokerServiceLogsTab";
import { BrokerBillingTab } from "@/components/brokerPortal/BrokerBillingTab";
import { BrokerTeamTab } from "@/components/brokerPortal/BrokerTeamTab";

const TABS = {
  dashboard: BrokerDashboardTab,
  "post-load": BrokerPostLoadTab,
  loads: BrokerLoadsTab,
  "find-drivers": BrokerFindDriversTab,
  "my-drivers": BrokerMyDriversTab,
  groups: BrokerGroupsTab,
  "service-logs": BrokerServiceLogsTab,
  billing: BrokerBillingTab,
  team: BrokerTeamTab,
};

export default function BrokerPortal() {
  const user = useAuth();
  const [active, setActive] = useState("dashboard");
  const isBroker = (user?.role || "").toLowerCase() === "broker";

  if (!isBroker) {
    return (
      <>
        <Header />
        <BrokerPortalGate signedInAsWrongRole={!!user} />
      </>
    );
  }

  const ActiveTab = TABS[active];
  return (
    <div data-testid="broker-portal-page" className="min-h-screen bg-rr-surface">
      <Header />
      <div className="pt-32 pb-20 max-w-6xl mx-auto px-5 md:px-8">
        <div className="flex flex-wrap items-center justify-between gap-2 mb-1">
          <h1 className="font-heading text-2xl md:text-3xl font-extrabold text-rr-navy">Broker Portal</h1>
          <span data-testid="broker-portal-signed-in-as" className="text-sm text-rr-muted font-semibold">Signed in as {user.name || user.email}</span>
        </div>
        <p className="text-rr-muted text-sm mb-8">Manage your driver network, loads, offers, and billing.</p>
        <BrokerPortalNav active={active} onChange={setActive} />
        <ActiveTab onCreated={() => setActive("loads")} />
      </div>
      <Footer />
    </div>
  );
}
